<div class="phone-update-container">
  <!-- Toast Message Component -->
     <div *ngIf="showToast" class="toast-container">
    <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
        <div class="toast-content">
        <div class="toast-text" aria-live="polite" aria-atomic="true">
          <div class="toast-message-text">{{ toastMessage }}</div>
        </div>
         <span class="material-symbols-outlined p-0 cursor-pointer" 
         id="btn_phone_update_recovery_email_close_toast"
      (click)="closeToast()"
      (keypress)="closeToast()"
      *ngIf="toastType === 'error' || toastType === 'success'" 
      title="Close">close</span>
      </div>
    </div>
  </div>  
  <div class="form-wrapper">
    <div class="header mt-4">
     <div class="row justify-content-center mt-2 mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img id="img_phone_update_recovery_email_edu_logo" src="assets/images/edu-logo.svg" alt="NDE logo" class="img-fluid" />
            </div>
        </div>
    </div>

    <div class="horizontal-line"></div>

    <div class="form-container">
      <h2>Update Recovery Email</h2>
      
      <form [formGroup]="recoveryEmailForm" (ngSubmit)="onSubmit()">
        <div class="recovery-title" >
          <div class="d-flex" style="position:relative;">
              <label for="input_phone_update_recovery_email_recovery_email" style="font-size: 14px;">Enter New Recovery Email<span class="requiredfield text-danger">*</span></label>
              <span class="ml-1 tooltip-icon" style="position:relative;"
                  (mouseenter)="recoveryEmailTooltip = true" (mouseleave)="recoveryEmailTooltip = false">
                  <span class="material-symbols-outlined f-16">info</span>
                  <span *ngIf="recoveryEmailTooltip" class="material-symbols-outlined inverted-arrow" style="position:absolute; top:-16px;padding: 0; left:50%; transform:translateX(-50%);">arrow_drop_down</span>
                  <div *ngIf="recoveryEmailTooltip" class="email-tooltip-box">
                    <div class="ssn-tooltip-polygon"></div>
                    <div class="email-tooltip-frame" aria-live="polite" aria-atomic="true" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                      {{genericMessage['G0002']}}
                    </div>
                  </div>
                </span>
                </div>
    
          <div class="" [ngClass]="
                (recoveryEmailForm.get('recoveryEmail')?.touched && recoveryEmailForm.get('recoveryEmail')?.invalid)? 'is-invalid':''
              ">
            <input
              type="email"
              id="input_phone_update_recovery_email_recovery_email"
              formControlName="recoveryEmail"
              class="form-control input-container"
              placeholder="user@example.com"
              tabindex="0"
              maxlength="255"
              (input)="checkEmail()"
              >
               
                </div>
        </div>
      <div *ngIf="recoveryEmailForm.get('recoveryEmail')?.touched && recoveryEmailForm.get('recoveryEmail')?.errors as errors" >
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0014'] }}</div>
                <div *ngIf="!errors['required'] && errors['pattern']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0015'] }}
                </div>
          </div>
        <div class="button-container d-flex justify-content-between">
          <button 
            type="button"
            class="cancel-btn me-3" 
            id="btn_phone_update_recovery_email_cancel"
            (click)="onCancel()"
          >Cancel
          </button>
          <button type="submit" id="btn_phone_update_recovery_email_submit" class="submit-btn" [disabled]="isSubmitDisabled">
            <span *ngIf="isLoading"
          class="spinner-border spinner-border-sm" output="status" aria-hidden="true"></span>
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
